<template>
  <div class="dettaglio-trasferte" v-loading="loading">
    <div class="header-tab row row-custom">
      <div class="return col-6">
        <icon v-if="$route.name === 'home' ? false : true" name="riv-arrow2" scale="1.2" flip="horizontal"
          @click.native="link('RiepilogoTrasferte')"></icon>
      </div>
      <div class="col-12">
        <span class="my-label">{{ $t('trasferte.label.title').toUpperCase() }}</span>
        <span class="my-label-subtitle">{{ getStato() }}</span>
      </div>
      <div class="col-6 inoltraBtn">
        <el-button class="WEB-button WEB-button-primary right" style="width: 200px !important;"
          v-if="enableAction('sendResp')" @click="inoltraTrasferta('1')">{{ $t('trasferte.btn.sendResp') }}</el-button>
        <el-button class="WEB-button WEB-button-primary right" style="width: 200px !important;"
          v-if="enableAction('sendSeg')" @click="inoltraPrenotazioni('1')"> {{ $t('trasferte.btn.sendSecretary')
          }}</el-button>
      </div>

    </div>


    <div class="testata-trasferte row row-custom">
      <div class="colonna col-md-12 col-24">
        <div class="blocco">
          <div class="elemento row row-custom">
            <div class="testata-label col-md-8 col-10">
              {{ $t('trasferte.label.periodo') }}
            </div>
            <div class="testata-value col-md-16 col-14" v-if="trasferta.tipoTrasferta === 'ORE'">
              {{ trasferta.dataDal | formattaData }} {{ '(' + trasferta.oraDal + ' - ' + trasferta.oraAl +')'}}
            </div>
            <div class="testata-value col-md-16 col-14" v-else>
              {{ trasferta.dataDal | formattaData }} - {{ trasferta.dataAl | formattaData }}
            </div>
          </div>
          <div class="elemento row row-custom" v-if="trasferta.tipoTrasferta === 'ORE'">
            <div class="testata-label col-md-8 col-10">
              {{ $t('trasferte.label.numOre') }}
            </div>
            <div class="testata-value col-md-16 col-14">
              {{ trasferta.oreTrasferta }}
            </div>
          </div>
          <div class="elemento row row-custom">
            <div class="testata-label col-md-8 col-10">
              {{ $t('trasferte.label.partenza') }} / {{ $t('trasferte.label.destinazione') }}
            </div>
            <div class="testata-value col-md-16 col-14">
              {{ trasferta.desProv }} / {{ trasferta.desDest === undefined ? trasferta.desMan : trasferta.desDest }}
            </div>
          </div>
          <!--<div class="elemento row row-custom">
            <div class="testata-label col-md-8 col-10">
              {{ $t('trasferte.label.destinazione') }}
            </div>
            <div class="testata-value col-md-16 col-14">
              {{ trasferta.desDest === '' ? trasferta.desMan : trasferta.desDest}}
            </div>
          </div>-->
          <div class="elemento row row-custom">
            <div class="testata-label col-md-8 col-10">
              {{ $t('trasferte.label.soc') }}
            </div>
            <div class="testata-value col-md-16 col-14">
              {{ trasferta.desCli }} <span style="text-transform: capitalize">( {{ trasferta.desUff !== undefined ?
                trasferta.desUff.toLowerCase() : '' }} )</span>
            </div>
          </div>
          <div class="elemento row row-custom">
            <div class="testata-label col-md-8 col-10">
              {{ $t('trasferte.label.referente') }}
            </div>
            <div class="testata-value col-md-16 col-14"
              v-if="trasferta.contatti !== undefined && trasferta.contatti.length > 0">
              <el-tag :key="tag.mail" v-for="tag in trasferta.contatti" :disable-transitions="false">
                {{ tag.mail }}
              </el-tag>
            </div>
            <div class="testata-value col-md-16 col-14" v-else>
              {{ trasferta.perRif }}
            </div>

          </div>
        </div>

      </div>

      <div class="colonna col-md-12 col-24">

        <div class="blocco">
          <!--<div class="elemento row row-custom">
            <div class="testata-label col-md-8 col-10">
              {{ $t('trasferte.label.dataFin') }}
            </div>
            <div class="testata-value col-md-16 col-14">
              {{ trasferta.dataAl | formattaData }}
            </div>
          </div>
          <div class="elemento row row-custom">
            <div class="testata-label col-md-8 col-10">
              {{ $t('trasferte.label.destinazione') }}
            </div>
            <div class="testata-value col-md-16 col-14">
              {{ trasferta.desDest === '' ? trasferta.desMan : trasferta.desDest}}
            </div>
          </div>
          <div class="elemento row row-custom">
            <div class="testata-label col-md-8 col-10">
              {{ $t('trasferte.label.uffRep') }}
            </div>
            <div class="testata-value col-md-16 col-14">
              {{ trasferta.desUff }}
            </div>
          </div>-->
          <div class="elemento row row-custom">
            <div class="testata-label col-md-8 col-10">
              {{ $t('trasferte.label.motivo') }}
            </div>
            <div class="testata-value col-md-16 col-14" v-html="getMotivo(trasferta.notaDip)"
              style="white-space: pre-line">
            </div>
          </div>
        </div>

      </div>
    </div>


    <el-tabs v-model="tabActive" type="card" class="col-24" v-loading="loading">
      <el-tab-pane>
        <div style="width: 200px" slot="label">
          <div class="col-24 no-padding">
            {{ $t('trasferte.label.diario').toUpperCase() }}
          </div>
          <div class="col-24 no-padding barra"></div>
        </div>

        <diario v-if="tabActive === '0'" :trasferta="trasferta" :tbl_genSta="tbl_genSta" :tbl_socFat="tbl_socFat"
          :key="trasferta.idTrasferta" :actionBar="true"></diario>

      </el-tab-pane>

      <el-tab-pane>
        <div style="width: 200px" slot="label">
          <div class="col-24 no-padding">
            {{ $t('trasferte.label.ticket').toUpperCase() }}
          </div>
          <div class="col-24 no-padding barra"></div>
        </div>

        <biglietti v-if="tabActive === '1'" :trasferta="trasferta" :key="trasferta.idTrasferta" :actionBar="true">
        </biglietti>

      </el-tab-pane>

      <el-tab-pane>
        <div style="width: 200px" slot="label">
          <div class="col-24 no-padding">
            {{ $t('trasferte.label.trasporti').toUpperCase() }}
          </div>
          <div class="col-24 no-padding barra"></div>
        </div>

        <trasporti v-if="tabActive === '2'" :trasferta="trasferta" :key="trasferta.idTrasferta" :actionBar="true">
        </trasporti>

      </el-tab-pane>
      <el-tab-pane>
        <div style="width: 200px" slot="label">
          <div class="col-24 no-padding">
            {{ $t('trasferte.label.auto').toUpperCase() }}
          </div>
          <div class="col-24 no-padding barra"></div>
        </div>

        <auto v-if="tabActive === '3'" :trasferta="trasferta" :tbl_genSta="tbl_genSta" :key="trasferta.idTrasferta"
          :actionBar="true"></auto>
      </el-tab-pane>

      <el-tab-pane>
        <div style="width: 200px" slot="label">
          <div class="col-24 no-padding">
            {{ $t('trasferte.label.doc').toUpperCase() }}
          </div>
          <div class="col-24 no-padding barra"></div>
        </div>

        <documenti v-if="tabActive === '4'" :trasferta="trasferta" :key="trasferta.idTrasferta" :actionBar="true">
        </documenti>
      </el-tab-pane>
    </el-tabs>

  </div>
</template>
<script>
import Diario from './Diario.vue'
import Biglietti from './Biglietti.vue'
import Trasporti from './Trasporti.vue'
import Auto from './AutoAziendali.vue'
import Documenti from './Documenti.vue'

export default {
  components: {
    Auto,
    Trasporti,
    Biglietti,
    Diario,
    Documenti
  },
  name: 'DettaglioTrasferta',
  i18n: {
    messages: {
      it_IT: {
        trasferte: {
          label: {
            title: "Trasferta",
            dataIn: 'Data Inizio',
            dataFin: 'Data Fine',
            partenza: 'Partenza',
            destinazione: 'Destinazione',
            soc: 'Per conto della Società',
            uffRep: 'Ufficio/Reparto',
            referente: 'Persona di Riferimento',
            motivo: 'Motivazione',
            mensa: 'Mensa',
            alloggio: 'Alloggio',
            diario: 'Diario di Viaggio',
            ticket: 'Biglietto',
            trasporti: 'Trasporto',
            auto: 'Vettura Società',
            doc: 'Documenti',
            periodo: 'Periodo',
            numOre: 'Num. Ore'
          },
          btn: {
            sendResp: 'Inoltra al Responsabile',
            sendSecretary: 'Sollecita la Segreteria',
          }
        }
      },
      fr_FR: {
        trasferte: {
          label: {
            title: 'Deplacement',
            dataIn: 'Date du',
            dataFin: 'Date au',
            partenza: 'Départ',
            destinazione: 'Destination',
            soc: 'Pour le compte',
            uffRep: 'Bureau/département',
            referente: 'Personne de référence',
            motivo: 'Motif',
            mensa: 'Repas',
            alloggio: 'Hébergement',
            diario: 'Détail du voyage',
            ticket: 'Réserver Billets Voyage',
            trasporti: 'Transports',
            auto: 'Voiture',
            doc: 'Documents',
            periodo: 'Date du-au'
          },
          btn: {
            sendResp: 'Envoyer au responsable',
            sendSecretary: 'Rappeler au Secrétariat',
          }
        }
      },
      es_ES: {
        trasferte: {
          label: {
            title: 'Viaje',
            dataIn: 'Dia salida',
            dataFin: 'Dia regreso',
            partenza: 'Salida',
            destinazione: 'Destino',
            soc: 'Por cuenta de la sociedad',
            uffRep: 'Oficina/Empresa',
            referente: 'Persona de referencia',
            motivo: 'Referencia',
            mensa: 'Comedor',
            alloggio: 'Alojamiento',
            diario: 'Agenda de viaje',
            ticket: 'Ticket',
            trasporti: 'Transporte',
            auto: 'Coche',
            doc: 'Documentos',
            periodo: 'Fecha desde-hasta'
          },
          btn: {
            sendResp: 'Enviar al Responsable',
            sendSecretary: 'Recordar a la Secretaría',
          }
        }
      },
      de_DE: {
        trasferte: {
          label: {
            title: 'Dienstreise',
            dataIn: 'Reisebeginn',
            dataFin: 'Reiseende',
            partenza: 'Abreiseort',
            destinazione: 'Reiseziel',
            soc: 'auf Kosten der Firma',
            uffRep: 'Büro/Abteilung',
            referente: 'Ansprechpartner',
            motivo: 'Grund',
            mensa: 'Kantine',
            alloggio: 'Unterkunft',
            diario: 'Reiseplan',
            ticket: 'Ticket',
            trasporti: 'Transport',
            auto: 'Firmenfahrzeug',
            doc: 'Dokumenten-Management',
            periodo: 'Datum von-bis'
          },
          btn: {
            sendResp: 'an den Beauftragten senden',
            sendSecretary: 'Update für das Sekretariat',
          }
        }
      },
      en_GB: {
        trasferte: {}
      }
    }
  },
  data() {
    return {
      loading: false,
      idTrasferta: '',
      tabActive: '-1',
      tbl_genSta: [],
      tbl_genStaFat: [],
      tbl_socFat: [],
      trasferta: {}
    }
  },
  filters: {
    /* Formatta la data: GGMMAAAA --> GG/MM/AAAA */
    formattaData: function (date) {
      if (date !== undefined && date !== '') {
        return date.substr(6, 2) + '/' + date.substr(4, 2) + '/' + date.substr(0, 4)
      } else {
        return ' '
      }
    }
  },
  /*watch: {
    '$route'(to, from) {
      if (to.name === 'DettaglioTrasferta') {
        this.loading = true
        this.tabActive = '-1'
        this.idTrasferta = this.$route.params.id
        this.loadGenSta()
        this.loadGenStaFat()
        //this.loadSocfat()
        this.loadTrasferta(this.$route.params.id)
      }
    }
  },*/
  activated: function () {
    this.loading = true
    this.tabActive = '-1'
    this.idTrasferta = this.$route.params.id
    this.loadGenSta()
    this.loadGenStaFat()
    this.loadSocfat()
    this.loadTrasferta(this.$route.params.id)
  },
  deactivated: function () {
    this.resetDati()
  },
  beforeMount: function () {
    /*this.loading = true
    this.idTrasferta = this.$route.params.id
    this.loadGenSta()
    this.loadGenStaFat()
    this.loadSocfat()
    this.loadTrasferta(this.$route.params.id)*/
  },
  mounted: function () {
  },
  methods: {
    link: function (route) {
      this.$router.push({ name: route })
    },
    resetDati: function () {
      this.$set(this, 'tbl_genSta', [])
      this.$set(this, 'tbl_genStaFat', [])
      this.$set(this, 'tbl_socFat', [])
      this.$set(this, 'trasferta', {})
      this.$set(this, 'loading', false)
      this.$set(this, 'idTrasferta', '')
      this.$set(this, 'tabActive', '-1')
    },
    loadTrasferta: function (idTrasferta) {
      this.loading = true
      this.$http.get('trasferte/' + this.$store.state.country + '/trasferte', {
        params: {
          idTrasferta: idTrasferta
        }
      })
        .then(response => {
          if (response.body.rc === 0) {
            this.trasferta = response.body.data[0]
            this.tabActive = '0'
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
          this.loading = false
        })
    },
    inoltraTrasferta: function (statoAvanz) {
      this.loading = true
      let obj = {
        'idTrasferta': this.idTrasferta,
        'operazione': '*UPD',
        'statoAvanz': statoAvanz,
      }
      this.$http.post('trasferte/' + this.$store.state.country + '/trasferta', obj)
        .then(response => {
          if (response.body.rc === 0) {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'success',
              duration: process.env.duration
            })
            this.tabActive = '-1'
            this.loadTrasferta(this.idTrasferta)
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
            this.loading = false
          }
        })
    },
    inoltraPrenotazioni: function () {
      this.loading = true
      let obj = {
        idTrasferta: this.idTrasferta,
        tipo: 'trasf',
        idPrenotazioni: [
          { id: '*ALL' }
        ],
        numId: '1',
      }
      this.$http.post('trasferte/' + this.$store.state.country + '/inoltraprenotazioni', obj)
        .then(response => {
          this.inoltraTrasferta('4')
          this.loading = false
        })
    },
    loadGenSta: function () {
      this.$http.get('datisoc/' + this.$store.state.country + '/gensta')
        .then(response => {
          if (response.body.rc === 0) {
            this.tbl_genSta = response.body.data
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
          this.loading = false
        })
    },
    loadGenStaFat: function () {
      this.$http.get('datisoc/' + this.$store.state.country + '/gensta', {
        params: {
          socFat: 'Y'
        }
      }).then(response => {
        if (response.body.rc === 0) {
          this.tbl_genStaFat = response.body.data
        } else {
          this.$message({
            showClose: true,
            message: response.body.msg[0].msgTxt,
            type: 'error',
            duration: process.env.duration
          })
        }
        this.loading = false
      })
    },
    loadSocfat: function () {
      this.$http.get('datisoc/' + this.$store.state.country + '/socfat')
        .then(response => {
          if (response.body.rc === 0) {
            this.tbl_socFat = response.body.data
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
          this.loading = false
        })
    },
    getStato: function () {
      if (this.trasferta.terminata === 'T') {
        return '(' + this.$i18n.t('status.t') + ')'
      } else {
        return '(' + this.$i18n.t('status.' + this.trasferta.statoAvanz) + ')'
      }
    },
    enableAction: function (action) {
      let statoTrasferta = this.trasferta.statoAvanz
      if (this.trasferta.terminata === 'T') {
        return false
      }
      switch (action) {
        case 'sendResp':
          if (statoTrasferta === '' || statoTrasferta === '0') {
            return true
          } else {
            return false
          }
        case 'sendSeg':
          if (statoTrasferta === '3' || statoTrasferta === '4' || statoTrasferta === '6') {
            return true
          } else {
            return false
          }
      }
      return false
    },

    getMotivo: function (nota) {
      return nota !== undefined ? nota.replace(/\\n|\\r\\n|\\n\\r|\\r/g, '<br>') : ''
    }
  }
}
</script>

<style lang="less">
@import "../../assets/less/general.less";
@import "../../assets/less/el-table.less";

.dettaglio-trasferte {
  .header-tab {
    height: 80px;
    text-align: center;

    .return {
      margin-top: 12px;
      line-height: 55px;
      height: 45px;
      float: left;
      .set-font(@color: @greenRiva, @weight: bold);

      .fa-icon {
        float: left;
        cursor: pointer;
      }
    }

    .my-label {
      display: block;
      line-height: 55px;
      height: 45px;
      .set-font(@color: @oroRiva, @size: 22px, @weight: bold, @family: 'os-semibolditalic');
      letter-spacing: 2px;
    }

    .my-label-subtitle {
      display: block;
      .set-font(@size: 15px, @weight: normal, @family: 'os-lightitalic');
      height: 25px;
    }

    .inoltraBtn {
      float: right;
      padding-top: 12px;
      padding-right: 10px;
    }

  }

  .testata-trasferte {
    height: auto;

    .colonna-md {
      margin-left: 1px;
    }

    .colonna {
      height: 100%;
      margin-top: 20px;

      .blocco {
        .elemento {
          height: auto;

          .testata-label {
            .set-font(@color: @greenRiva; @size: 15px);
            display: inline;
            text-align: right;
            line-height: 16px;
            height: 22px;
            padding-top: 5px;
            padding-bottom: 5px;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .testata-value {
            .set-font(@color: #454848; @size: 13px);
            display: inline;
            text-align: left;
            word-wrap: break-word;
            white-space: normal;
            line-height: 16px;
            min-height: 26px;
            height: 100%;
            border-left: 1px solid @oroRiva;
            padding-top: 5px;
            padding-bottom: 5px;

            .icona {
              color: #54e912;
            }
          }
        }
      }

      .secondo-blocco {
        margin-top: 20px;
      }
    }
  }

  .el-tabs {
    margin-top: 40px;

    .el-tabs__header {
      border-bottom: 1px solid #ccc;
      margin-bottom: 0px;

      .el-tabs__nav-wrap {
        margin-top: 0px;
      }

      .el-tabs__nav-wrap::after {
        display: none;
      }

      .el-tabs__nav {
        border: 0px;
        height: 33px;

        .el-tabs__item {
          text-align: center;
          padding-left: 0px;
          padding-right: 0px;
          border: 0px;
          height: 30px;
          line-height: 30px;
          .set-font(@color: #999);
          letter-spacing: 1px;

          &.is-active {
            .set-font(@weight: bold);

            // background-color: #efe8da;
            .barra {
              background-image: linear-gradient(to right, @oroRiva, @greenRiva);
              height: 3px;
            }
          }
        }

        .el-tabs__item:hover {
          color: @greenRiva;
        }
      }
    }

    .el-tabs__content {
      /*.el-table::before {
          height: 0px;
        }
        .el-table {
          border-bottom: none;
          overflow: auto;
          margin-bottom: 10px;
          .el-table__header {
            border-bottom: 1px solid #007c74;
            thead {
              th {
                padding: 7px 0px;
                .cell {
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  padding-left: 10px !important;
                  .set-font(@color: @greenRiva; @weight: bold; @size: 15px);
                }
              }
            }
          }
          .el-table__body {
            tbody {
              tr {
                td {
                  padding: 7px 0px;
                  .cell {
                    line-height: 16px;
                    width: 100%;
                    .set-font(@size: 13px; @color: #454848);
                    .bottoni-alert {
                      display: grid;
                      .icon {
                        margin-bottom: 3px;
                        margin-left: 3px;
                      }
                    }
                  }
                }
              }
            }
          }
        }*/
    }
  }
}

/*
    .el-button {
      border: 1px solid @oroRiva;
      color: @oroRiva;
      border-radius: 0px;
      font-size: 12px;
      text-transform: uppercase;
      letter-spacing: 2px;
      -moz-box-shadow: 3px 3px 4px #cccccc;
      -webkit-box-shadow: 3px 3px 4px #cccccc;
      box-shadow: 3px 3px 4px #cccccc;
      padding: 8px 12px;
    }
    .el-button:hover {
      border: 1px solid @oroRiva;
      background-color: @white;
      color: @oroRiva;
    }
    .el-button--primary {
      background-color: @oroRiva;
      border-color: @oroRiva;
      color: @white;
      font-size: 12px;
      letter-spacing: 2px;
    }
    .el-button--primary:hover {
      background-color: @oroRiva;
      color: @white;
    }
  */
.status-saved {
  color: @grayMedium;
}

.status-send {
  color: @orangeMedium;
}

.status-approved {
  color: @greenApproved
}

.status-rejected,
.status-delete {
  color: #f44336
}

/*
   .el-button {
     margin-top: 10px;
     .set-font(@size: 12px; @weight: normal);
     float: right;
     letter-spacing: 3px;
     border: 1px solid @oroRiva;
     background-color: @oroRiva;
     color: @white;
     border-radius: 0px;
     -moz-box-shadow: 3px 3px 4px #cccccc;
     -webkit-box-shadow: 3px 3px 4px #cccccc;
     box-shadow: 3px 3px 4px #cccccc;
     margin-bottom: 10px;
     float: right;
     text-transform: uppercase
   }
   .el-button:hover {
     background-color: @oroRiva;
     color: @white;
     border: 1px solid @oroRiva;
   }
 */
</style>



// WEBPACK FOOTER //
// src/components/Trasferte/DettaglioTrasferta.vue